import type { AgenticFillInConfig } from '@omnea-app/packages/universal/task-agents/agentContracts'

export const DEFAULT_INHERENT_RISK_INSTRUCTIONS = `This form is an inherent risk assessment of the supplier engagement described in the request. Assess each dimension independently — do not reuse evidence from one dimension to justify another.

Sometimes the evidence for a factor within a form response may directly conflict with evidence about that factor discovered during web research. In this case, use best judgement about whether a published data point is more reliable than one given by a user filling out an assessment form to decide on how to score the factor. Include all the relevant evidence in the citations for a dimension, even if two sources contradict each other — this is useful context for a user who reviews your output.

Unlike the general rule to omit unsupported questions, answer every dimension. When the evidence does not address a factor, leave that factor out of the rationale. When it does not address the dimension at all, score it from the general profile of the engagement — supplier, product and request — open the rationale by saying the assessment is inferred, and set confidence to LOW. Weak or inferred evidence lowers confidence, not the score.`

// The block exists to produce a score, so the agent always completes its task rather than handing an
// uncertain one to a human.
export const INHERENT_RISK_AGENT_AUTONOMY: NonNullable<AgenticFillInConfig['autonomy']> = {
  enabled: true,
  minConfidence: 'LOW',
  allowUnreadableContext: true,
}

export const DEFAULT_INHERENT_RISK_AGENT_CONFIG: AgenticFillInConfig = {
  enabled: true,
  instructions: DEFAULT_INHERENT_RISK_INSTRUCTIONS,
  slices: {
    web_research: { enabled: true },
    other_request_forms: { enabled: true },
  },
  autonomy: INHERENT_RISK_AGENT_AUTONOMY,
}
